export const REVERIFY_CURRENT_EMAIL_VERIFICATION_SENT_PAYLOAD_DEFINITION = {
    definitionParts: []
};
